"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttendingLeaveApiResponseSchema = exports.attendingLeaveEntrySchema = exports.getAttendingLeaveApiPayloadSchema = void 0;
const zod_1 = require("zod");
const event_schema_1 = require("../global/event.schema");
exports.getAttendingLeaveApiPayloadSchema = zod_1.z.object({
    rangeStart: zod_1.z.string().date(),
    rangeEnd: zod_1.z.string().date(),
});
exports.attendingLeaveEntrySchema = zod_1.z.object({
    date: zod_1.z.string(),
    period: zod_1.z.enum(event_schema_1.periodsOfTheDayWithoutAllday),
});
exports.getAttendingLeaveApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.attendingLeaveEntrySchema),
});
